module.exports = __webpack_public_path__ + "img/p-single-2.ad709317.jpg";